import { useState } from "react";
import AppBar from "@mui/material/AppBar";
import {
  Box,
  ListItemButton,
  Toolbar,
  IconButton,
  Button,
  Avatar,
  List,
  ListItem,
  useMediaQuery,
  Theme,
} from "@mui/material";
import { VogoIcon } from "../../assets/svg/Appbar/VogoIcon";
import { NotificationIcon } from "../../assets/svg/Appbar/NotificationIcon";
import { MassageIcon } from "../../assets/svg/Appbar/MassageIcon";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const pages = ["Home", "Profile", "Messages", "Opportunities"];
const items = [
  {
    name: "Home",
  },
  {
    name: "Profile",
  },
  {
    name: "Messages",
  },
  {
    name: "Opportunities",
  },
];

type Props = {
  isMobile: boolean;
  isLargeScreen: boolean;
  onOpenMenu: () => void;
  isOpenedMenu: boolean;
};

export const Appbar = ({
  isMobile,
  isLargeScreen,
  onOpenMenu,
  isOpenedMenu,
}: Props) => {
  const isHovered = (itemName: string) => hoveredItem === itemName;
  const [selectedItem, setSelectedItem] = useState<string>("Dashboard");
  const [hoveredItem, setHoveredItem] = useState<null | string>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const handleItemClick = (itemName: string) => {
    setSelectedItem(itemName);
    switch (itemName) {
      case "Home":
        navigate("/");
        break;
      case "Profile":
        navigate("/profile");
        break;
      case "Messages":
        navigate("/messages");
        break;
      case "Opportunities":
        navigate("/");
        break;
      default:
    }
  };

  const isSelected = (itemName: string) => {
    switch (itemName) {
      case "Home":
        return location.pathname === "/";
      case "Profile":
        return location.pathname.startsWith("/profile");
      case "Messages":
        return location.pathname.startsWith("/messages");
      case "Opportunities":
        return location.pathname.startsWith("/opportunities");
      default:
        return false;
    }
  };

  return (
    <AppBar sx={{ boxShadow: "unset", gap: "20px", background: "#E8E8E8" }}>
      <Box
        sx={{
          width: "100%",
          height: 72,
          background: "#F3F3F3",
          paddingLeft: "40px",
          paddingRight: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "static",
        }}
      >
        <VogoIcon />
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <IconButton
            sx={{
              height: 48,
              width: 48,
              border: "2px solid #E8E8E8",
              borderRadius: "50%",
            }}
          >
            <MassageIcon />
          </IconButton>
          <IconButton
            sx={{
              height: 48,
              width: 48,
              border: "2px solid #E8E8E8",
              borderRadius: "50%",
            }}
          >
            <NotificationIcon />
          </IconButton>
          <IconButton
            sx={{
              height: 48,
              width: 48,
              border: "2px solid #E8E8E8",
              borderRadius: "50%",
            }}
          >
            <Avatar />
          </IconButton>
        </Box>
      </Box>
      <Box
        sx={{
          paddingLeft: {
            xs: "0px",
            sm: "40px",
          },
          paddingRight: {
            xs: "0px",
            sm: "40px",
          },
        }}
      >
        <Toolbar
          sx={{
            width: "100%",
            background: "#FFF",
            borderRadius: "10px",
            padding: "12px !important",
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          {isMobile && (
            <Box sx={{ position: "absolute", top: "10px", right: "10px" }}>
              <Button onClick={onOpenMenu}>
                {isOpenedMenu ? <CloseIcon /> : <MenuIcon />}
              </Button>
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              gap: "4px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            {items.map((item, index) => (
              <Button
                key={`${item.name}+${index}`}
                onClick={() => handleItemClick(item.name)}
                sx={{
                  color: isSelected(item.name) ? "#FFF" : "#111926",
                  backgroundColor: isSelected(item.name)
                    ? "#1C85FB"
                    : "inherit",

                  paddingLeft: "14px",
                  paddingRight: "14px",
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  fontSize: 16,
                  fontWeight: 700,
                  lineHeight: "16px",
                  textTransform: "unset",
                  borderRadius: "8px",
                  display: isLargeScreen || isOpenedMenu ? "block" : "none",
                  "&:hover": {
                    backgroundColor: "#F3F3F3",
                    color: "#111926",
                  },
                }}
              >
                {item.name}
              </Button>
            ))}
          </Box>
          <Button
            variant="text"
            sx={{
              color: "#111926",
              paddingLeft: "14px",
              paddingRight: "14px",
              paddingTop: "12px",
              paddingBottom: "12px",
              fontSize: 16,
              fontWeight: 700,
              lineHeight: "16px",
              textTransform: "unset",
              display: isLargeScreen || isOpenedMenu ? "block" : "none",
            }}
          >
            Communities
          </Button>
        </Toolbar>
      </Box>
    </AppBar>
  );
};
